/*
  LOULEX-Anpassung (#30): Verhalten der nativen Anmeldeformulare.

  0. Anmeldung: Formulare mit data-klaviyo-list senden die Adresse per fetch an Klaviyos
     Client-Subscriptions-API (developers.klaviyo.com/en/reference/create_client_subscription)
     in die Liste der Instanz; Erfolg (202) wird ohne Neuladen angezeigt. Bot-Schutz:
     Honeypot-Feld und Mindestzeit seit der ersten Interaktion; ein Treffer zeigt den
     Erfolg nur an, sendet aber nichts. Fehler zeigt den Fehlertext, das Formular bleibt.
     Kein Cookie, keine weitere Anfrage; credentials: 'omit'.

  1. Erfolgszustand des Shopify-Rückfalls (ohne JavaScript): Das Formular schickt seine ID
     als return_to mit, Shopify springt auf "?loulex-signup=<ID>" zurück (verifiziert
     2026-09-14). Dieses Formular bekommt data-posted und zeigt den Erfolgsblock, alle
     anderen behalten ihr Formular. Danach wird die Adresse bereinigt.

  2. <loulex-popup>: erbt von Prestiges PopIn/DialogElement (Dialog-Rolle, Fokus-Trap,
     Escape, Scroll-Sperre). Die Klasse wird erst definiert, wenn das Modul-Bundle
     "pop-in" registriert hat; die Elemente nehmen dann den Upgrade-Pfad, weshalb der
     Konstruktor keine Attribute liest.

  3. Koordination: Je Seitenaufruf ist nur eine Popup-Instanz aktiv, die mit der
     kleinsten Priorität (Gleichstand: Reihenfolge im Dokument). Nur sie startet ihre
     Auslöser. Auslöser: Verzögerung (Desktop/Mobil getrennt), Exit-Intent (Desktop,
     frühestens nach der Verzögerung, mit Rückfall nach fester Zeit), Scrolltiefe.

  4. Speicher im Endgerät: dauerhaft (localStorage) nur bei Präferenz-Einwilligung über
     window.loulexConsent (snippets/loulex-consent.liquid), sonst sessionStorage. Gelesen
     wird aus beiden, damit ein früher gespeicherter Wert nicht verloren geht.
     Schlüssel: "loulex-popup:<section>" mit closedAt, "loulex-signup:subscribed" nach
     einer Eintragung (kein Popup mehr, egal welche Instanz). Die Pause beginnt wie bei
     Klaviyos Formularen erst beim Schließen; wer ohne Schließen weiterklickt, sieht das
     Popup auf der nächsten Seite wieder (ältere Einträge mit shownAt gelten weiter).

  5. Messung: Anzeige, Schließen und Eintragung im Popup gehen als popup_view, popup_close und
     popup_submit direkt an GA4, über das gtag der Google & YouTube App auf der Seite (siehe
     sendPopupEvent), nur mit Analyse-Einwilligung. Fehlt gtag oder die Privacy-API nach
     10 s, geht nichts raus.
     Mit jeder Anmeldung gehen Merkmale als Profil-Eigenschaften an Klaviyo (signup_country,
     signup_device, signup_page, signup_trigger, signup_utm_*), nur die vorhandenen; fehlt
     eines, wird es weggelassen. UTM-Parameter kommen aus der aktuellen Adresse; für spätere
     Seiten der Sitzung werden sie nur mit Analyse-Einwilligung zwischengespeichert.
*/
(function () {
  'use strict';

  var SUBSCRIBED_KEY = 'loulex-signup:subscribed';
  var POSTED_KEY = 'loulex-signup:posted';
  var DAY = 24 * 60 * 60 * 1000;
  var CONSENT_GRACE_MS = 2500; // Abstand zwischen Cookie-Entscheidung und Popup
  var isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* --------------------------------------------------------------------------
     Speicher
     -------------------------------------------------------------------------- */

  function safe(fn, fallback) {
    try {
      return fn();
    } catch (e) {
      return fallback;
    }
  }

  function persistentAllowed() {
    return !!(window.loulexConsent && window.loulexConsent.allowed('preferences'));
  }

  function readState(key) {
    var raw = safe(function () { return window.localStorage.getItem(key); }, null);
    if (raw === null) raw = safe(function () { return window.sessionStorage.getItem(key); }, null);
    if (raw === null) return null;
    return safe(function () { return JSON.parse(raw); }, null);
  }

  function writeState(key, value) {
    var raw = JSON.stringify(value);
    if (persistentAllowed()) {
      safe(function () { window.localStorage.setItem(key, raw); });
      safe(function () { window.sessionStorage.removeItem(key); });
    } else {
      safe(function () { window.sessionStorage.setItem(key, raw); });
    }
  }

  /* --------------------------------------------------------------------------
     Erfolgszustand nach dem Rücksprung
     -------------------------------------------------------------------------- */

  function postedFormId() {
    var fromUrl = safe(function () { return new URLSearchParams(window.location.search).get('loulex-signup'); }, null);
    var fromSession = safe(function () { return window.sessionStorage.getItem(POSTED_KEY); }, null);
    safe(function () { window.sessionStorage.removeItem(POSTED_KEY); });
    return fromUrl || fromSession || null;
  }

  var posted = postedFormId();
  var subscribedNow = false;

  function resolvePostedState() {
    var wrappers = document.querySelectorAll('[data-loulex-signup]');
    Array.prototype.forEach.call(wrappers, function (wrapper) {
      if (posted && wrapper.getAttribute('data-loulex-signup') === posted) {
        wrapper.setAttribute('data-posted', '');
        subscribedNow = true;
        writeState(SUBSCRIBED_KEY, { at: Date.now() });
      } else {
        wrapper.removeAttribute('data-posted');
      }
    });

    // Rücksprung-Parameter und Anker aus der Adresse nehmen, damit ein Neuladen oder ein
    // geteilter Link nicht wieder den Erfolgszustand zeigt.
    if (posted && window.history && window.history.replaceState) {
      safe(function () {
        var url = new URL(window.location.href);
        if (url.searchParams.has('loulex-signup') || url.searchParams.has('customer_posted')) {
          url.searchParams.delete('loulex-signup');
          url.searchParams.delete('customer_posted');
          url.hash = '';
          window.history.replaceState(window.history.state, '', url.toString());
        }
      });
    }

    // Die Formular-ID vor dem Absenden festhalten (nur Shopify-Rückfall ohne Klaviyo-Liste).
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.classList.contains('loulex-form')) return;
      if (form.getAttribute('data-klaviyo-list')) return;
      safe(function () { window.sessionStorage.setItem(POSTED_KEY, form.id); });
    });

    // Fokus auf die Erfolgsmeldung der Sektion (nicht im Popup; das übernimmt der Dialog).
    if (subscribedNow) {
      var success = document.querySelector('[data-loulex-signup="' + posted + '"]:not(.loulex-popup__panel) [data-loulex-success]');
      if (success) {
        success.focus({ preventScroll: false });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resolvePostedState);
  } else {
    resolvePostedState();
  }

  /* --------------------------------------------------------------------------
     Anmeldung direkt bei Klaviyo
     -------------------------------------------------------------------------- */

  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var KLAVIYO_REVISION = '2026-07-15';
  var MIN_INTERACTION_MS = 1000; // Bots senden in Millisekunden; Autofill plus Klick braucht länger

  /* Postfach-Hilfe: Anbieter an der Domain erkennen und direkt zum Postfach verlinken, damit
     die Bestätigungsmail schneller gefunden wird (das frühere Klaviyo-Popup zeigte dafür
     feste Logos). Gmail sucht direkt nach Mails von loulex.eu, auch im Spam. */
  var MAILBOXES = [
    { name: 'Gmail', url: 'https://mail.google.com/mail/u/0/#search/from%3Aloulex.eu+in%3Aanywhere', domains: ['gmail.com', 'googlemail.com'] },
    { name: 'Outlook', url: 'https://outlook.live.com/mail/0/', domains: ['outlook.com', 'outlook.de', 'outlook.fr', 'hotmail.com', 'hotmail.de', 'hotmail.fr', 'hotmail.it', 'hotmail.es', 'hotmail.co.uk', 'live.com', 'live.de', 'live.fr', 'live.nl', 'msn.com'] },
    { name: 'Yahoo Mail', url: 'https://mail.yahoo.com/', domains: ['yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.it', 'yahoo.es', 'yahoo.co.uk', 'ymail.com'] },
    { name: 'iCloud Mail', url: 'https://www.icloud.com/mail', domains: ['icloud.com', 'me.com', 'mac.com'] },
    { name: 'GMX', url: 'https://www.gmx.net/', domains: ['gmx.de', 'gmx.net', 'gmx.at', 'gmx.ch'] },
    { name: 'WEB.DE', url: 'https://web.de/', domains: ['web.de'] },
    { name: 'T-Online', url: 'https://email.t-online.de/', domains: ['t-online.de'], hint: true },
    { name: 'Proton Mail', url: 'https://mail.proton.me/', domains: ['proton.me', 'protonmail.com', 'pm.me'] },
    { name: 'Orange', url: 'https://mail.orange.fr/', domains: ['orange.fr', 'wanadoo.fr'] },
    { name: 'Free', url: 'https://webmail.free.fr/', domains: ['free.fr'] },
    { name: 'Interia', url: 'https://poczta.interia.pl/', domains: ['interia.pl'] },
    { name: 'WP Poczta', url: 'https://poczta.wp.pl/', domains: ['wp.pl'] },
    { name: 'o2 Poczta', url: 'https://poczta.o2.pl/', domains: ['o2.pl'] }
  ];

  function mailboxFor(email) {
    var domain = (email.split('@')[1] || '').toLowerCase();
    for (var i = 0; i < MAILBOXES.length; i++) {
      if (MAILBOXES[i].domains.indexOf(domain) !== -1) return MAILBOXES[i];
    }
    return null;
  }

  function showInbox(wrapper, email) {
    var inbox = wrapper && wrapper.querySelector('[data-loulex-inbox]');
    if (!inbox || !email) return;

    // Adresse als Text einsetzen, nie als HTML
    var sentTo = inbox.querySelector('[data-loulex-sent-to]');
    var parts = (inbox.getAttribute('data-sent-to') || '__EMAIL__').split('__EMAIL__');
    sentTo.textContent = '';
    sentTo.appendChild(document.createTextNode(parts[0] || ''));
    var strong = document.createElement('strong');
    strong.textContent = email;
    sentTo.appendChild(strong);
    sentTo.appendChild(document.createTextNode(parts.slice(1).join('__EMAIL__')));

    var box = mailboxFor(email);
    var open = inbox.querySelector('[data-loulex-inbox-open]');
    var hint = inbox.querySelector('[data-loulex-inbox-hint]');
    if (box) {
      open.href = box.url;
      open.textContent = (inbox.getAttribute('data-open-mailbox') || '__PROVIDER__').replace('__PROVIDER__', box.name);
    }
    open.hidden = !box;
    hint.hidden = !(box && box.hint);
    inbox.hidden = false;
  }

  // „Andere Adresse eingeben": Formular wieder zeigen, Feld leeren und fokussieren
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-loulex-inbox-change]');
    if (!button) return;
    var wrapper = button.closest('[data-loulex-signup]');
    if (!wrapper) return;
    wrapper.removeAttribute('data-posted');
    var inbox = wrapper.querySelector('[data-loulex-inbox]');
    if (inbox) inbox.hidden = true;
    var input = wrapper.querySelector('.loulex-form__input');
    if (input) {
      input.value = '';
      input.focus();
    }
  });

  function markSubscribed(form) {
    var wrapper = form.closest('[data-loulex-signup]');
    if (wrapper) wrapper.setAttribute('data-posted', '');
    var email = form.querySelector('input[name="contact[email]"]');
    showInbox(wrapper, email ? email.value.trim() : '');
    writeState(SUBSCRIBED_KEY, { at: Date.now() });
    var success = wrapper ? wrapper.querySelector('[data-loulex-success]') : null;
    if (success) success.focus({ preventScroll: form.closest('loulex-popup') !== null });
  }

  function setBusy(form, busy) {
    var button = form.querySelector('.loulex-form__submit');
    if (button) {
      button.disabled = busy;
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    }
  }

  function showError(form, visible) {
    var error = form.querySelector('[data-loulex-error]');
    if (error) error.hidden = !visible;
  }

  function looksLikeBot(form) {
    var trap = form.querySelector('[data-loulex-trap]');
    if (trap && trap.value) return true;
    var since = Number(form.getAttribute('data-loulex-first-touch') || 0);
    return !since || Date.now() - since < MIN_INTERACTION_MS;
  }

  /* Merkmale der Anmeldung. Jeder Wert ist optional: Fehlt einer oder wirft ein Zugriff,
     bleibt nur dieser Schlüssel weg, die Anmeldung selbst läuft unverändert. */
  var UTM_KEY = 'loulex-signup:utm';
  var UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign'];

  function clean(value) {
    if (typeof value !== 'string') return '';
    return value.trim().slice(0, 100);
  }

  function utmFromUrl() {
    var params = safe(function () { return new URLSearchParams(window.location.search); }, null);
    var utm = {};
    if (!params) return utm;
    UTM_FIELDS.forEach(function (field) {
      var value = clean(params.get(field));
      if (value) utm[field] = value;
    });
    return utm;
  }

  function analyticsAllowed() {
    return safe(function () { return !!(window.loulexConsent && window.loulexConsent.allowed('analytics')); }, false);
  }

  // Einstiegs-UTM für die Sitzung merken, nur mit Einwilligung (auch wenn sie erst später kommt).
  function rememberUtm() {
    var utm = utmFromUrl();
    if (!Object.keys(utm).length || !analyticsAllowed()) return;
    safe(function () { window.sessionStorage.setItem(UTM_KEY, JSON.stringify(utm)); });
  }

  // Die Consent-API lädt oft erst nach diesem Skript; ready() wartet darauf.
  safe(function () { window.loulexConsent.ready(rememberUtm); });
  safe(function () { window.loulexConsent.onChange(rememberUtm, 'analytics'); });

  function currentUtm() {
    var utm = utmFromUrl();
    if (Object.keys(utm).length) return utm;
    if (!analyticsAllowed()) return {};
    var stored = safe(function () { return JSON.parse(window.sessionStorage.getItem(UTM_KEY)); }, null);
    return stored && typeof stored === 'object' ? stored : {};
  }

  function signupProperties(form) {
    var popup = form.closest('loulex-popup');
    var values = {
      signup_country: clean(form.getAttribute('data-country')),
      signup_device: isDesktop ? 'desktop' : 'mobile',
      signup_page: clean(safe(function () { return window.location.pathname; }, '')),
      signup_trigger: clean(popup && popup.trigger)
    };
    var utm = currentUtm();
    UTM_FIELDS.forEach(function (field) {
      values['signup_' + field] = clean(utm[field]);
    });

    var properties = {};
    Object.keys(values).forEach(function (key) {
      if (values[key]) properties[key] = values[key];
    });
    return properties;
  }

  function subscribeAtKlaviyo(form) {
    var email = form.querySelector('input[name="contact[email]"]');
    var listId = form.getAttribute('data-klaviyo-list');
    var companyId = form.getAttribute('data-klaviyo-company');
    var source = form.getAttribute('data-klaviyo-source') || '';
    var locale = form.getAttribute('data-locale') || '';

    var attributes = {
      email: email.value.trim(),
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    };
    if (locale) attributes.locale = locale;
    var properties = safe(function () { return signupProperties(form); }, null);
    if (properties && Object.keys(properties).length) attributes.properties = properties;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: attributes } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };

    return window.fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('klaviyo ' + response.status);
    });
  }

  document.addEventListener('focusin', function (event) {
    var form = event.target.closest && event.target.closest('.loulex-form[data-klaviyo-list]');
    if (form && !form.hasAttribute('data-loulex-first-touch')) {
      form.setAttribute('data-loulex-first-touch', String(Date.now()));
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('loulex-form')) return;
    var listId = form.getAttribute('data-klaviyo-list');
    if (!listId || !window.fetch) return; // Rückfall: Shopify-Kundenformular

    event.preventDefault();
    var email = form.querySelector('input[name="contact[email]"]');
    if (!email || !email.checkValidity()) {
      if (email && email.reportValidity) email.reportValidity();
      return;
    }

    showError(form, false);

    // Honeypot oder zu schnell: Erfolg zeigen, nichts senden.
    if (looksLikeBot(form)) {
      markSubscribed(form);
      return;
    }

    setBusy(form, true);
    subscribeAtKlaviyo(form).then(function () {
      setBusy(form, false);
      markSubscribed(form);
      var popup = form.closest('loulex-popup');
      if (popup) sendPopupEvent('popup_submit', popup);
    }).catch(function () {
      setBusy(form, false);
      showError(form, true);
      // Der deaktivierte Button hat den Fokus verloren; zurück ins Feld zum Korrigieren.
      email.focus();
    });
  });

  /* --------------------------------------------------------------------------
     Popup
     -------------------------------------------------------------------------- */

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var candidates = [];
  var chosen = null;
  var selectionScheduled = false;

  // Hängt von der Google & YouTube App ab: Sie legt window.gtag samt Einwilligung und config
  // für G-40M1LHRVE6 erst zur Laufzeit an. Deshalb nichts vorab in den dataLayer schieben,
  // sondern auf gtag warten (alle 250 ms, höchstens 10 s). Ersetzt das frühere Custom Pixel,
  // dessen eigenes gtag in der Sandbox scroll/session_start mit Sandbox-URL erzeugte.
  // Gesendet wird nur mit Analyse-Einwilligung, egal wie die App Ablehnungen behandelt:
  // Datenschutzerklärung „ohne Einwilligung kein GA4“, das Custom Pixel lief ebenso nur
  // mit Einwilligung. Ohne Einwilligung wird das Ereignis verworfen, nicht nachgeholt.
  var GA_ID = 'G-40M1LHRVE6';

  function sendPopupEvent(name, popup) {
    var params = {
      send_to: GA_ID,
      form_id: popup.formId,
      device: isDesktop ? 'desktop' : 'mobile',
      popup_trigger: popup.trigger || '',
      // ohne Query: Mail-Links tragen Kennungen wie Klaviyos _kx
      page_location: window.location.origin + window.location.pathname
    };
    // Fordert die Privacy-API an, falls sie auf der Seite noch niemand geladen hat.
    if (window.loulexConsent) window.loulexConsent.ready(function () {});
    var waited = 0;
    (function attempt() {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (typeof window.gtag === 'function' && privacy) {
        if (safe(function () { return privacy.analyticsProcessingAllowed() === true; }, false)) {
          safe(function () { window.gtag('event', name, params); });
        }
      } else if (waited < 10000) {
        waited += 250;
        window.setTimeout(attempt, 250);
      }
    })();
  }

  function fadeControls(element, from, to) {
    var animation = element.animate([{ opacity: from }, { opacity: to }], {
      duration: reducedMotion ? 0 : 320,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      fill: 'both'
    });
    return {
      finished: animation.finished,
      finish: function () { animation.finish(); }
    };
  }

  /* Nur ein Banner, das wirklich im Dokument sichtbar ist, zählt. Die API allein reicht
     nicht: In WebKit meldet sie nach einer Weiterleitung "Banner nötig", ohne eines zu
     rendern (siehe #55); das Popup würde sonst nie erscheinen. */
  function consentBannerOpen() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var apiSaysOpen = safe(function () { return !!(privacy && typeof privacy.shouldShowBanner === 'function' && privacy.shouldShowBanner()); }, false);
    if (!apiSaysOpen) return false;
    var banner = document.querySelector('#shopify-pc__banner');
    if (!banner) return false;
    var style = window.getComputedStyle(banner);
    return style.display !== 'none' && style.visibility !== 'hidden' && banner.getClientRects().length > 0;
  }

  function selectCandidate() {
    selectionScheduled = false;
    if (chosen || candidates.length === 0) return;
    candidates.sort(function (a, b) {
      if (a.config.priority !== b.config.priority) return a.config.priority - b.config.priority;
      return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
    chosen = candidates[0];
    chosen.arm();
  }

  function scheduleSelection() {
    if (selectionScheduled) return;
    selectionScheduled = true;
    // Alle Instanzen einer Seite werden im selben Upgrade-Durchlauf verbunden; danach wählen.
    window.setTimeout(selectCandidate, 0);
  }

  function define() {
    var PopIn = window.customElements.get('pop-in');
    if (!PopIn || window.customElements.get('loulex-popup')) return;

    var LoulexPopup = class extends PopIn {
      constructor() {
        super();
        this.loulexOnBackdropClick = this.loulexOnBackdropClick.bind(this);
        this.loulexOnExitIntent = this.loulexOnExitIntent.bind(this);
        this.loulexOnScroll = this.loulexOnScroll.bind(this);
      }

      /* PopIn schaltet den Fokus-Trap ab (Ecken-Pop-in); hier ist es ein echter Dialog. */
      get shouldTrapFocus() {
        return true;
      }

      get shouldLock() {
        return true;
      }

      /* Der Rahmen selbst bekommt den Anfangsfokus (tabindex="-1"), nicht das E-Mail-Feld:
         Shopify bindet hCaptcha beim Fokus ins Feld und lädt dann js.hcaptcha.com. Das soll
         erst passieren, wenn die Person das Feld selbst wählt. */
      get initialFocus() {
        return this;
      }

      /* Klicks außerhalb behandelt der Rahmen selbst (er füllt den Viewport). */
      get clickOutsideDeactivates() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();
        this.setAttribute('aria-modal', 'true');

        var configNode = this.querySelector('[data-loulex-config]');
        this.config = safe(function () { return JSON.parse(configNode.textContent); }, {}) || {};
        this.config.priority = Number(this.config.priority) || 0;
        this.config.delay = Number(this.config.delay) || 0;
        this.config.delayMobile = Number(this.config.delayMobile) || 0;
        this.config.scrollDepth = Number(this.config.scrollDepth) || 0;
        this.config.exitFallback = Number(this.config.exitFallback) || 0;
        this.config.pauseDays = Number(this.config.pauseDays) || 0;

        this.formId = this.getAttribute('data-form-id');
        this.storageKey = this.getAttribute('data-storage-key');
        this.armed = false;
        this.shown = false;

        this.addEventListener('click', this.loulexOnBackdropClick, { signal: this.abortController.signal });
        this.addEventListener('dialog:before-show', this.loulexOnBeforeShow.bind(this), { signal: this.abortController.signal });
        this.addEventListener('dialog:after-show', this.loulexOnAfterShow.bind(this), { signal: this.abortController.signal });
        this.addEventListener('dialog:before-hide', this.loulexOnBeforeHide.bind(this), { signal: this.abortController.signal });

        // Nach erfolgreichem Absenden aus diesem Popup: sofort mit Erfolgsmeldung öffnen.
        if (posted && posted === this.formId) {
          this.show(false);
          return;
        }

        if (this.hasAttribute('design-mode') || this.hasAttribute('data-ineligible')) return;
        if (!this.loulexEligible()) return;

        candidates.push(this);
        scheduleSelection();
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        this.loulexDisarm();
        var index = candidates.indexOf(this);
        if (index !== -1) candidates.splice(index, 1);
        if (chosen === this) chosen = null;
      }

      createEnterAnimationControls() {
        return fadeControls(this, 0, 1);
      }

      createLeaveAnimationControls() {
        return fadeControls(this, 1, 0);
      }

      loulexEligible() {
        var device = this.config.device || 'all';
        if (device === 'desktop' && !isDesktop) return false;
        if (device === 'mobile' && isDesktop) return false;

        if (readState(SUBSCRIBED_KEY)) return false;

        var state = readState(this.storageKey);
        var pausedAt = state && (state.closedAt || state.shownAt);
        if (pausedAt && Date.now() - pausedAt < this.config.pauseDays * DAY) return false;

        return true;
      }

      /* Auslöser starten; nur die gewählte Instanz kommt hierher. */
      arm() {
        if (this.armed) return;
        this.armed = true;

        var self = this;
        var delay = isDesktop ? this.config.delay : this.config.delayMobile;
        this.delayElapsed = false;
        this.exitSeen = false;
        this.scrollReached = this.config.scrollDepth <= 0;
        this.wantsExit = !!this.config.exitIntent && isDesktop;

        this.delayTimer = window.setTimeout(function () {
          self.delayElapsed = true;
          self.loulexTryShow('delay');
        }, delay * 1000);

        if (this.wantsExit) {
          // mouseout mit relatedTarget null (Chrome, Firefox) und mouseleave am Wurzelelement
          // (WebKit meldet das Verlassen des Fensters so zuverlässiger).
          document.addEventListener('mouseout', this.loulexOnExitIntent, { signal: this.abortController.signal });
          document.documentElement.addEventListener('mouseleave', this.loulexOnExitIntent, { signal: this.abortController.signal });

          // Rückfall: Wer so lange auf der Seite stöbert, sieht das Popup auch ohne Exit-Intent
          // (Weiterklicken über Links oder Tab per Tastenkürzel schließen lösen keinen aus).
          if (this.config.exitFallback > 0) {
            this.fallbackTimer = window.setTimeout(function () {
              if (!self.exitSeen) self.exitVia = 'exit_fallback';
              self.exitSeen = true;
              self.loulexTryShow();
            }, this.config.exitFallback * 1000);
          }
        }

        if (!this.scrollReached) {
          window.addEventListener('scroll', this.loulexOnScroll, { passive: true, signal: this.abortController.signal });
          this.loulexOnScroll();
        }
      }

      loulexDisarm() {
        if (this.delayTimer) window.clearTimeout(this.delayTimer);
        if (this.fallbackTimer) window.clearTimeout(this.fallbackTimer);
        if (this.graceTimer) window.clearTimeout(this.graceTimer);
        document.removeEventListener('mouseout', this.loulexOnExitIntent);
        document.documentElement.removeEventListener('mouseleave', this.loulexOnExitIntent);
        window.removeEventListener('scroll', this.loulexOnScroll);
      }

      /* Zeiger verlässt das Fenster nach oben: relatedTarget fehlt, Y am oberen Rand oder
         darüber. Ein kleiner Toleranzbereich fängt schnelle Bewegungen ab, bei denen das
         letzte gemeldete Y noch knapp im Fenster liegt. */
      loulexOnExitIntent(event) {
        if (event.relatedTarget) return;
        if (event.clientY > 10) return;
        if (!this.exitSeen) this.exitVia = 'exit';
        this.exitSeen = true;
        this.loulexTryShow();
      }

      loulexOnScroll() {
        var scrollable = document.documentElement.scrollHeight - window.innerHeight;
        var depth = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 100;
        if (depth >= this.config.scrollDepth) {
          this.scrollReached = true;
          window.removeEventListener('scroll', this.loulexOnScroll);
          this.loulexTryShow('scroll');
        }
      }

      /* trigger: mit Exit-Intent dessen Weg (exit oder exit_fallback, auch wenn er vor Ablauf
         der Verzögerung kam), sonst der Auslöser, der die letzte Bedingung erfüllt hat. Der
         erste Aufruf mit allen Bedingungen legt ihn fest; spätere (Cookie-Entscheidung,
         Ruhepause) ändern ihn nicht. */
      loulexTryShow(trigger) {
        if (this.shown || !this.delayElapsed || !this.scrollReached) return;
        if (this.wantsExit && !this.exitSeen) return;
        if (!this.trigger) this.trigger = this.wantsExit ? this.exitVia : trigger;

        // Auf die Cookie-Entscheidung warten (welche, ist egal): Das Popup ist modal und sperrt
        // Klicks außerhalb, das Banner wäre sonst nicht bedienbar; mobil deckt es zudem die Seite ab.
        var self = this;
        if (!this.consentAt && consentBannerOpen()) {
          if (!this.waitingForBanner) {
            this.waitingForBanner = true;
            // Das Ereignis kommt, bevor das Banner aus dem Dokument verschwindet; deshalb
            // zählt die Entscheidung selbst, nicht die Sichtbarkeit.
            document.addEventListener('visitorConsentCollected', function () {
              self.consentAt = Date.now();
              self.loulexTryShow();
            }, { once: true, signal: this.abortController.signal });
          }
          return;
        }
        // Kurze Ruhe nach der Entscheidung, damit nicht ein Overlay das nächste ablöst.
        var sinceConsent = this.consentAt ? Date.now() - this.consentAt : Infinity;
        if (sinceConsent < CONSENT_GRACE_MS) {
          window.clearTimeout(this.graceTimer);
          this.graceTimer = window.setTimeout(function () { self.loulexTryShow(); }, CONSENT_GRACE_MS - sinceConsent);
          return;
        }

        this.shown = true;
        this.loulexDisarm();
        this.show();
      }

      loulexOnBeforeShow() {
        if (posted === this.formId) return;
        sendPopupEvent('popup_view', this);
      }

      loulexOnBeforeHide() {
        if (posted === this.formId) return;
        writeState(this.storageKey, { closedAt: Date.now() });
        sendPopupEvent('popup_close', this);
      }

      loulexOnAfterShow() {
        var success = this.querySelector('[data-loulex-success]');
        if (success) success.focus({ preventScroll: true });
      }

      loulexOnBackdropClick(event) {
        var target = event.target;
        if (target.closest('[data-loulex-close]')) {
          this.hide();
          return;
        }
        if (target.hasAttribute('data-loulex-backdrop')) {
          this.hide();
        }
      }
    };

    window.customElements.define('loulex-popup', LoulexPopup);
  }

  if (window.customElements.get('pop-in')) {
    define();
  } else {
    window.customElements.whenDefined('pop-in').then(define);
  }
})();
